import {Injectable} from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
    providedIn: 'root'
})
export class SchoolService {

    constructor(public commonService: CommonService) {
    }

    async getExternalUnits() {
        try {
            const request: any = await this.commonService.getList('class/externalSchoolUnit');
            return request.object;
        } catch (e) {
            throw e;
        }
    }

    async getExternalLevels() {
        try {
            const request: any = await this.commonService.getList('class/externalSchoolLevel');
            return request.object;
        } catch (e) {
            throw e;
        }
    }

    async getExternalClasses() {
        try {
            const request: any = await this.commonService.getList('class/externalSchoolClass');
            return request.object;
        } catch (e) {
            throw e;
        }
    }

    async getExternalDepartments() {
        try {
            const request: any = await this.commonService.getList('class/externalSchoolClassDepartment');
            return request.object;
        } catch (e) {
            throw e;
        }
    }
}
